/** 南亚等 BSC 渗透高：默认 USDT + BSC */
export const DEPOSIT_GEO_USDT_BSC_COUNTRIES = new Set(['IN', 'PK', 'BD', 'NP', 'LK', 'NG', 'ID']);

/** 南欧等：默认 USDC + Polygon（无 Polygon 时降级 ETH） */
export const DEPOSIT_GEO_USDC_POLYGON_COUNTRIES = new Set([
  'ES',
  'IT',
  'PT',
  'GR',
  'RO',
  'BG',
  'HR',
  'SI',
]);

/** 欧美、东亚发达市场：默认 USDC + Ethereum */
export const DEPOSIT_GEO_USDC_ETH_COUNTRIES = new Set([
  'US',
  'CA',
  'GB',
  'DE',
  'FR',
  'NL',
  'BE',
  'AT',
  'CH',
  'SE',
  'NO',
  'DK',
  'FI',
  'IE',
  'PL',
  'CZ',
  'SK',
  'HU',
  'LT',
  'LV',
  'EE',
  'LU',
  'MT',
  'CY',
  'IS',
  'LI',
  'MC',
  'AU',
  'NZ',
  'JP',
  'KR',
  'TW',
  'AD',
  'SM',
  'VA',
  'RS',
  'ME',
  'MK',
  'AL',
  'BA',
  'MD',
  'UA',
  'FO',
  'GL',
  'GI',
  'JE',
  'GG',
  'IM',
]);

/** 东南亚、中东、拉美、非洲、大中华等：默认 USDT + Tron */
export const DEPOSIT_GEO_USDT_TRON_COUNTRIES = new Set([
  'SG',
  'MY',
  'TH',
  'PH',
  'VN',
  'KH',
  'LA',
  'MM',
  'BN',
  'TL',
  'CN',
  'HK',
  'MO',
  'AE',
  'SA',
  'QA',
  'KW',
  'BH',
  'OM',
  'JO',
  'LB',
  'IL',
  'TR',
  'IQ',
  'YE',
  'PS',
  'SY',
  'IR',
  'MX',
  'BR',
  'AR',
  'CO',
  'CL',
  'PE',
  'VE',
  'EC',
  'BO',
  'PY',
  'UY',
  'CR',
  'PA',
  'GT',
  'HN',
  'SV',
  'NI',
  'DO',
  'PR',
  'ZA',
  'KE',
  'GH',
  'TZ',
  'UG',
  'ET',
  'EG',
  'MA',
  'DZ',
  'TN',
  'LY',
  'SD',
  'SN',
  'CI',
  'CM',
  'AO',
  'MZ',
  'ZW',
  'ZM',
  'RW',
  'BW',
  'NA',
  'RU',
  'BY',
  'KZ',
  'UZ',
  'TM',
  'TJ',
  'KG',
  'AZ',
  'AM',
  'GE',
  'XK',
  'CU',
  'HT',
  'JM',
  'TT',
  'BB',
  'BS',
  'KY',
  'AW',
  'CW',
  'SX',
  'GP',
  'MQ',
  'GF',
  'RE',
  'YT',
  'PF',
  'NC',
]);

/**
 * @typedef {
 *   | 'usdc-eth'
 *   | 'usdc-polygon'
 *   | 'usdt-tron'
 *   | 'usdt-bsc'
 *   | 'fallback'
 * } DepositGeoBucket
 */

/**
 * @param {string | null | undefined} countryCode ISO 3166-1 alpha-2
 * @returns {DepositGeoBucket}
 */
export function resolveDepositGeoBucket(countryCode) {
  const code = String(countryCode ?? '')
    .trim()
    .toUpperCase();
  if (!code) return 'fallback';
  if (DEPOSIT_GEO_USDT_BSC_COUNTRIES.has(code)) return 'usdt-bsc';
  if (DEPOSIT_GEO_USDC_POLYGON_COUNTRIES.has(code)) return 'usdc-polygon';
  if (DEPOSIT_GEO_USDC_ETH_COUNTRIES.has(code)) return 'usdc-eth';
  if (DEPOSIT_GEO_USDT_TRON_COUNTRIES.has(code)) return 'usdt-tron';
  return 'fallback';
}
